export const MAX_NAME_LENGTH = 28;
export const CHEVRON_RECTANGLE_MIN_WIDTH = 60;
export const CHEVRONS_GAP = 10;
export const ICON_SIZE = 14;
export const CHEVRON_MIN_WIDTH = 93;
export const RECTANGLE_WIDTH = 9;
